import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PageComponent from '../PageComponent';

export default class CmsDriven extends Component {
  static propTypes = {
    accessToken: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      pageComponents: [],
      components: []
    };
  }

  componentDidMount() {
    const { accessToken } = this.props;

    const currentUrl = window.location.pathname;
    const origin = window.location.origin;

    if (currentUrl) {
      const cmsdriven = require('cmsdriven');
      const client = cmsdriven.createClient({
        accessToken: accessToken
      });

      let components = require('../../../cmsdriven').default;
      this.setState({ ...this.state, components: components });

      // This API call will request a page access.
      client.getPage(currentUrl, origin).then(pageComponents => {
        this.setState({ ...this.state, pageComponents: pageComponents });
      });
    }
  }

  render() {
    if (Object.keys(this.state.components).length < 1) {
      return <div />;
    }

    return (
      <div>
        {this.state.pageComponents.map((pageComponent, index) => (
          <PageComponent
            key={index}
            components={this.state.components}
            pageComponent={pageComponent}
          />
        ))}
      </div>
    );
  }
}
